import React, { useContext } from 'react';
import { CartContext } from '../cart/CartContext'; 
import Header from '../Header';
import Navbar from '../Navbar';
import Footers from '../Footers';
import './Cart.css';

const Cart = () => {
  const { cartItems, removeFromCart } = useContext(CartContext);

  // 🔢 Calculate total price
  const totalPrice = cartItems.reduce((total, item) => total + item.price, 0);

  return (
    <div>
      <Header />
      <Navbar />
      <div className="cart-container">
        <h2>My Cart</h2>

        {cartItems.length === 0 ? (
          <p>Your cart is empty. <a href="/">Continue shopping</a></p>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map(item => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.name} className="cart-item-img" />
                  <div className="item-info">
                    <h4>{item.name || item.category}</h4>
                    <p>₹{item.price}</p>
                    <button onClick={() => removeFromCart(item.id)}>Remove</button>
                  </div>
                </div>
              ))}
            </div>

            {/* 💰 Total Amount Section */}
            <div className="cart-total">
              <h3>Total: ₹{totalPrice.toFixed(2)}</h3>
              <button className="checkout-btn">Proceed to Checkout</button>
            </div>
          </>
        )}
      </div>
      <Footers />
    </div>
  );
};

export default Cart;
